// extracted by mini-css-extract-plugin
export default {"link":"PatientLink_link__y-2Y6","linkIcon":"PatientLink_linkIcon__vB7RW","linkText":"PatientLink_linkText__D0omd"};